<template>
  <div>
    <div class="dashboard-head-bg"/>
    <div class="dashboard-head-content">
      <DashboardHeader
          :firstname=firstname
          :profile-picture-url=profilePictureUrl
      />
      <div class="dashboard-status">
        <div class="dashboard-status-content">
          <div class="dashboard-status-content-label">
            Dossier expiré
          </div>
          <div class="dashboard-status-content-progress">
            <ve-progress
                :progress="100"
                :size="100"
                color="#CBDB2A"
                emptyThickness="10%"
                line="square"
                thickness="10%"
            >
              <span class="dashboard-status-content-progress-legend">100%</span>
            </ve-progress>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-section" v-if="comments !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Un commentaire a été déposé sur votre espace</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ comments }}</pre>
          </div>
        </div>
      </div>

      <div class="dashboard-section" v-if="ofVacationDateAsString !== ''">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title"><img src="@/assets/img/raster.png">Congés annuels de votre centre de rattachement</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            <pre>{{ ofVacationDateAsString }}</pre>
          </div>
        </div>
      </div>


      <div class="dashboard-section dashboard-section--critical">
        <div class="dashboard-section-header">
          <div class="dashboard-section-header-title dashboard-section-header-title--critical"><img src="@/assets/img/raster.png">Important</div>
          <div><img class="dashboard-section-header-underline" src="@/assets/img/underline_critical.png"></div>
        </div>
        <div class="dashboard-section-content">
          <div class="dashboard-section-content-italic">
            Votre dossier de candidature est expiré : il ne sera plus visible auprès des employeurs. <br><br>Si vous êtes toujours candidat(e) à notre formation, nous vous invitons à actualiser votre dossier sur votre espace.
          </div>
        </div>
      </div>

      <div class="form-group" v-if="expiredButtonVisible">
        <button class="btn btn-primary btn-block" @click="toExtend">
          <span>Prolonger</span>
        </button>
      </div>
      <div class="form-group" v-if="expiredButtonVisible === false">
        <button class="btn btn-primary btn-block">
          <span>Patienter ...</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>

import DashboardHeader from '@/components/Dashboard/Header.vue'
import UserService from "@/services/user.service";
import ModalQuitter from "@/components/Modal/Questionnaire/Quitter.vue";
import Toast from "@/_helpers/AlerteHelper";

export default {
  name: "DashboardQualified",
  components: {
    ModalQuitter,
    DashboardHeader,
    UserService
  },
  props: {
    firstname: String,
    purcentage: Number,
    textDateConvocation: String,
    textCampusConvocation: String,
    comments: String,
    ofVacationDateAsString: String,
    profilePictureUrl: String,
  },
  data() {
    return {
      expiredButtonVisible: true
    }
  },
  methods: {
    toExtend: function () {
      let _ = this;
      this.expiredButtonVisible = false;
      Toast(
          'warning',
          'Pour prolonger votre candidature, vous devez confirmer les informations de votre formulaire de candidature et valider son dépôt',
          'top',
          20000)
      _.$router.push({name: 'ma-candidature-1'});
    }
  },
};
</script>
